/**
 * True when basic analytics uses getAnalyticsReport in AITS / all-in-one test
 * series shape: paper_type=3 with planner_test_id (see analyticsSaga + analyticsApi).
 */
export function isGetAnalyticsReportAitsStyle({
  testDetails,
  testType,
  routeState,
} = {}) {
  const paperType = Number(
    testType?.id ??
      testDetails?.paperType ??
      testDetails?.paper_type ??
      routeState?.paper_type
  );

  if (paperType !== 3) return false;

  const plannerTestId =
    testDetails?.planner_test_id ??
    routeState?.planner_test_id ??
    testDetails?.testId;

  return plannerTestId != null && String(plannerTestId).trim() !== "";
}

export default isGetAnalyticsReportAitsStyle;
